<template>
  <modal v-if="modalUserLogin" v-model:show="showModal" :showClose="false" :clickClose="false">
    <template v-slot:header>
      <h5 class="modal-title">
        You are about to login for the user {{ currentUser?.name }}
      </h5>
    </template>
    <form id="my-form">
      <div>
        <label for="recipient-name" class="text-black text-xs font-weight-bold text-capitalize">
          Users:
        </label>
        <base-input name="selectmultiple" class="w-100 mr-2">
          <el-select v-model="tempUserIds" filterable :collapse-tags="shouldCollapseTags" placeholder="Select Users"
            @change="handleSelectAll('user', $event)">
            <el-option v-for="option in sortedSelectOptions" :key="option.key" :label="option.value"
              :value="option.key">
            </el-option>
          </el-select>
        </base-input>
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
      <button class="btn btn-primary" type="button" @click="login()">Login</button>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
  <modal v-model:show="showVerifyModal" :showClose="false" :clickClose="false">
    <form>
      <div class="mb-3">
        <h1 class="display-1 mb-0 text-center text-primary">{{ randomNum }}</h1>
      </div>
      <div class="mb-3">
        <label for="user-input"
          class="text-black text-sm d-flex justify-content-center align-item-center font-weight-bold text-capitalize">
          please enter the provided number:
        </label>
        <input type="text" v-model="userInput" class="form-control d-flex justify-content-center align-item-center"
          id="user-input" maxlength="3" placeholder="Enter 3-digit number" />
      </div>
    </form>
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="goToPrevious()">Edit</button>
      <button class="btn btn-primary" type="button" @click="validateInput()">Verify</button>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ validationMessage }}</small>
    </div>
    <div v-if="errorFlag" class="mt-3 d-flex justify-content-center">
      <small class="text-danger">{{ errorMessage }}</small>
    </div>
  </modal>
</template>
<script>
import { ElSelect, ElOption } from "element-plus";
import Modal from "@/components/Modal";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  name: "UserLogin",
  components: {
    Modal,
    [ElSelect.name]: ElSelect,
    [ElOption.name]: ElOption,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    modalUserLogin: {
      type: Boolean,
      default: false,
    },
    currentUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      errorFlag: false,
      errorMessage: "",
      tempUserIds: [],
      selectOptions: [],
      showVerifyModal: false,
      randomNum: "",
      userInput: "",
      validationMessage: "",
    };
  },
  computed: {
    shouldCollapseTags() {
      const allUserIds = this.selectOptions.map((option) => option.key);
      return (
        this.tempUserIds.length > 10 ||
        this.tempUserIds.length === allUserIds.length
      );
    },
    sortedSelectOptions() {
      return [...this.selectOptions].sort((a, b) => {
        const isASelected = this.tempUserIds.includes(a.key);
        const isBSelected = this.tempUserIds.includes(b.key);
        if (isASelected === isBSelected) {
          return a.value.localeCompare(b.value);
        }
        return isASelected ? -1 : 1;
      });
    },
  },
  methods: {
    handleSelectAll(type, value) {
      if (type !== "user") return;
      const options = this.selectOptions;
      const selectAllKey = "select_all";
      const allKeys = options.map((option) => option.key);
      if (value.includes(selectAllKey)) {
        if (this.tempUserIds.length === allKeys.length + 1) {
          this.tempUserIds = [];
        } else {
          this.tempUserIds = [...allKeys];
        }
      } else {
        if (this.tempUserIds.includes(selectAllKey)) {
          this.tempUserIds = this.tempUserIds.filter(
            (v) => v !== selectAllKey
          );
        }
      }
    },
    closeModal() {
      this.errorFlag = false;
      this.errorMessage = "";
      this.tempUserIds = [];
      this.validationMessage = "";
      this.userInput = "";
      this.$emit("updateParameters", false, false);
    },
    getRandomNumber() {
      this.randomNum = Math.floor(100 + Math.random() * 900);
    },
    login() {
      this.getRandomNumber();
      this.$emit("updateParameters", false, this.modalUserLogin);
      this.showVerifyModal = true;
    },
    goToPrevious() {
      this.showVerifyModal = false;
      this.$emit("updateParameters", true, this.modalUserLogin);
    },
    validateInput() {
      if (parseInt(this.userInput) === this.randomNum) {
        this.validationMessage = "";
        this.userLogin();
      } else {
        this.errorFlag = false;
        this.validationMessage = "Incorrect number. Please try again.";
      }
    },
    async userLogin() {
      const self = this;
      const data = {
        otp: "123",
        userId: self.tempUserIds,
      };
      self.$store
        .dispatch("settingStore/userLogin", data, { root: true })
        .then(function () {
          self.showVerifyModal = false;
          self.$emit("updateParameters", false, false);
          swal.fire({
            title: "User Login!",
            text: "User login is successful.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
            icon: "success",
          });
          self.tempUserIds = [];
          self.userInput = "";
        })
        .catch(function (error) {
          self.errorFlag = true;
          self.errorMessage = error?.server?.response?.data?.message || "Error occurred";
        });
    },
    getActiveUsers() {
      const data = {
        type: "active-users",
      };
      const cacheKey = data.type + "-reference-data";
      if (sessionStorage.getItem(cacheKey)) {
        this.selectOptions = JSON.parse(sessionStorage.getItem(cacheKey));
      } else {
        this.$store
          .dispatch("commonStore/getReferenceData", data, { root: true })
          .then((response) => {
            this.selectOptions = response.server.data;
            sessionStorage.setItem(cacheKey, JSON.stringify(this.selectOptions));
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.getActiveUsers();
  },
};
</script>
